module.exports = __webpack_public_path__ + "static/media/orange_bogen_tn.32a30d0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/orange_bogen_tn.jpg
// module id = 746
// module chunks = 0